window.app.controller('subscribeCtrl', ['$scope', '$http', '$compile', '$mdDialog', function ($scope, $http, $compile, $mdDialog) {
        
    $scope.userEmail;
    
    $scope.parseResponse = function(response){
        $scope.userEmail='';

        if(response.data.subscribeSuccess){
            $scope.showAlertMessage('Subskrypcja jest aktywna.');
        }
        else{
            $scope.showAlertMessage('Już się zarejestrowałeś.');
        }
        
    } 

    $scope.sendSubscribeForm = function(){
        if($scope.userEmail){
            let subscribeData = { email: $scope.userEmail };
            let params = {
                url: '/rest/forms/subscriber-form/subscribe',
                data: subscribeData,
                successFunc: $scope.parseResponse,
            };
            $scope.sendXHR(params)
        }
        // else{$scope.showAlert('warning','Podaj e-mail');}
    }

    $scope.showAlertMessage = (text) => {
        $mdDialog.show({
            preserveScope: true,
            template:
            `<div id="modal-popup">
                <div class="layout" layout-align="end">
                    <span class="modal-close-btn" aria-label="close" ng-click="hideAlertMessage()">X</span>
                </div>
                <p class="title text-center">${text}</p>
            </div>`,
            parent: angular.element(document.body),
            scope: $scope,
        });
    }

    $scope.hideAlertMessage = () => {
        $mdDialog.hide();
    }

}])


// WEBPACK FOOTER //
// src/js/controllers/forms/subscribeCtrl.js